<div
  [attr.data-test]="'product-category--filters-active' + facetCategory().code + '-heading'"
  class="heading"
  (click)="toggleGroup($event)"
  [attr.aria-expanded]="expanded()"
  [attr.aria-label]="facetCategory().name"
  role="button"
  (click)="onOpenFacetCategoryPanel()"
  [ngClass]="{disabled: !facetCategory().facets.length}"
  #facetCategoryRef
>
  <mat-icon
    svgIcon="equalizer"
    [attr.data-test]="'product-category--filters-active' + facetCategory().code + '-equalizer-icon'"
  />
  <span
    class="body-medium"
    [attr.data-test]="'product-category--filters-active' + facetCategory().code + '-heading-name'"
  >{{ facetCategory().name }}</span>
  <mat-icon
    class="caret" svgIcon="arrow-right"
    [attr.data-test]="'product-category--filters-active' + facetCategory().code + '-caret-icon'"
  />
</div>

